import { Contact } from '../contact/contact';
import { ContactType } from '../contact/contact.type';
import { Entity } from '../entity';
import { Activity } from '../shared/activity';
import { Attachment } from '../shared/attachment';
import { ComplianceDefinition } from './compliance.definition';

export enum ComplianceDocumentSource {
    User = 'User',
    Tenant = 'Tenant',
    System = 'System'
}

export interface IndividualComplianceViewFilterValues {
    categories: string[];
    compliance?: IndividualComplianceDefinitionTiny[];
    status?: ComplianceDocumentStatus[];
    users?: Entity[];
}


export interface ComplianceDocument {
    _id: string;
    active: boolean;
    owner: Entity;
    definition: ComplianceDefinition;
    number?: string;
    start?: Date;
    end?: Date;
    attachments?: Attachment[];
    notes?: string;
    source: ComplianceDocumentSource;
    disabled: boolean;
    placeholder?: boolean;
    supersededBy?: string;
}

export enum ComplianceDocumentStatus {
    All = '',
    Valid = 'Valid',
    ExpiresSoon = 'Expires Soon',
    Expired = 'Expired',
    Missing = 'Missing',
    Inactive = 'Inactive',
    NewCompliance = 'New Compliance',
    Superseded = 'Superseded'
}


export interface ComplianceDocumentGroup {
    key: string;
    items: ComplianceDocumentSummary[];
}


export interface ComplianceLabelValue {
    label: string;
    value: Date | string;
}

export interface ComplianceDocumentSummary {
    _id: string;
    active?: boolean;
    definitionId: string;
    category: string;
    name: string;
    start?: ComplianceLabelValue;
    end?: ComplianceLabelValue;
    number: ComplianceLabelValue;
    status: ComplianceDocumentStatus;
    definition?: ComplianceDefinition;
    realStatus?: ComplianceDocumentStatus;
    blockAssignment?: boolean;
    owner: Entity;
    disabled?: boolean;
}

export interface ComplianceUserSelectedResponse {
    compliance: ComplianceDocumentSummary[];
    activities: Activity[];
}

export interface ComplianceSendEmailResponse {
    email: any;
    activities: Activity[];
}

export interface IndividualComplianceDefinitionTiny {
    _id: string;
    name: string;
    category: string;
}

export interface IndividualComplianceViewRequest {
    userType: ContactType;
    filter?: IndividualComplianceViewFilterRequest;
}

export interface IndividualComplianceViewFilterRequest {
    category?: string;
    compliance?: IndividualComplianceDefinitionTiny[];
    users?: Entity[];
    status?: ComplianceDocumentStatus;
    type?: string;
    userType?: ContactType;
    newOnly?: boolean;
}

export interface IndividualComplianceViewResponse {
    categories: string[];
    compliance?: IndividualComplianceDefinitionTiny[];
    users?: Partial<Contact>[];
    status?: ComplianceDocumentStatus[];
    allCount: number;
    missingCount: number;
    expiringCount: number;
    expiredCount: number;
    validCount: number;
    inactiveCount: number;
    newCount: number;
    filters: IndividualComplianceViewFilterValues;
}
